import React from 'react';
import { colors, typography } from '../../theme';

export const labelStyle: React.CSSProperties = {
  fontSize: typography.fontSize.base,
  fontFamily: typography.fontFamily.ui,
  color: colors.textMuted,
  marginBottom: 4
};

export const sectionStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 14
};

export const rowStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8
};

export const valueLabelStyle: React.CSSProperties = {
  fontSize: typography.fontSize.base,
  fontFamily: typography.fontFamily.ui,
  color: colors.textSecondary,
  minWidth: 32,
  textAlign: 'right'
};

export const inputStyle: React.CSSProperties = {
  padding: '6px 8px',
  border: `1px solid ${colors.border}`,
  borderRadius: 4,
  fontSize: typography.fontSize.base,
  fontFamily: typography.fontFamily.ui,
  background: colors.surfaceElevated,
  color: colors.textPrimary,
  outline: 'none'
};

export const sliderStyle: React.CSSProperties = {
  flex: 1,
  cursor: 'pointer'
};
